import {
    GlobalConfigsType,
    useGlobalConfigsStore,
} from "../Persistence/GlobalConfigsStore";
import { mappedGlobalConfigs } from "../../Presentation/DataFetchers/GlobalConfigsDataFetcher";
import { useCallback } from "react";
import { handleLocalStorageVersion } from "@infrastructure/Persistence/LocalUserStorage";

export enum CurrentStatusEnum {
    DATA_NOT_AVAILABLE,
    DATA_LOADING,
    DATA_AVAILABLE,
}

export const DEFAULT_GROUP_CHAT_PARTICIPANTS_LIMIT = 10;

export function useGlobalConfigs() {
    const { configs, setConfigs, dataStatus, setDataStatus } =
        useGlobalConfigsStore();

    const getConfigs: () => GlobalConfigsType | undefined = useCallback(() => {
        if (dataStatus === CurrentStatusEnum.DATA_AVAILABLE) {
            return configs;
        } else if (dataStatus === CurrentStatusEnum.DATA_LOADING) {
            return undefined;
        }
        setDataStatus(CurrentStatusEnum.DATA_LOADING);
        mappedGlobalConfigs().then((globalConfigs) => {
            handleLocalStorageVersion(globalConfigs.configVersion);
            setConfigs(globalConfigs);
            setDataStatus(CurrentStatusEnum.DATA_AVAILABLE);
        });
        return undefined;
    }, [configs, dataStatus, setConfigs, setDataStatus]);

    return {
        getConfigs,
        isDataLoaded: dataStatus === CurrentStatusEnum.DATA_AVAILABLE,
    };
}
